<script setup lang="ts">
defineProps<{
  image?: string
}>()
const nImageModalOpen = ref(false)
</script>

<template>
  <a
    @click="nImageModalOpen = true"
  >
    <slot />
  </a>
  <NModal :open="nImageModalOpen" @close="nImageModalOpen = false">
    <HDialogPanel
      class="max-w-2xl w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
    >
      <div class="absolute right-0 top-0 pr4 pt4">
        <div class="absolute pr4 pt4 -right-1 -top-1">
          <NButton
            id="close-size-chat-modal"
            n="lg borderless"
            icon="i-mingcute:close-line"
            class="p-0.25em text-context children:m-0"
            @click="nImageModalOpen = false"
          />
        </div>
      </div>
      <div>
        <div class="p4">
          <div class="flex items-center justify-between">
            <NuxtImg :src="image" class="h-auto w-full rounded-md" />
          </div>
        </div>
      </div>
    </HDialogPanel>
  </NModal>
</template>
